function calculateMinDiff(arr1, arr2) {
  const result = [];
  const processed = new Array(arr1.length).fill(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function deepEqual(obj1, obj2) {
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
      return obj1 === obj2;
    }
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  }
  arr2.forEach((item, index) => {
    const existingIndex = arr1.findIndex((x, i) => !processed[i] && deepEqual(x, item));
    if (existingIndex !== -1) {
      processed[existingIndex] = true;
      result.push({
        action: 'same',
        index: existingIndex,
        item
      });
    } else {
      result.push({
        action: 'add',
        index,
        item
      });
    }
  });
  arr1.forEach((item, index) => {
    if (!processed[index]) {
      result.push({
        action: 'delete',
        index,
        item
      });
    }
  });
  // Reindex the items in the result array
  const reindexedResult = result.map(diff => Object.assign(Object.assign({}, diff), {
    index: diff.action === 'delete' ? diff.index : result.findIndex(d => d === diff)
  }));
  // Sort the result array by the index property, giving precedence to 'delete'
  return reindexedResult.sort((a, b) => {
    if (a.index === b.index) {
      return a.action === 'delete' ? -1 : 1;
    }
    return a.index - b.index;
  });
}
export default calculateMinDiff;